import z from 'zod';

// See this thread for some ideas how to do this more robustly, although the solution provided as of March 1 is not actually correct: https://github.com/colinhacks/zod/discussions/2116

// TODO: would be cool to just have one GeoJsonFeatureSchema,
//   but it's a start for polygons
export const multiPolygonGeoJsonFeatureSchema = z.object({
  type: z.literal('MultiPolygon'),
  coordinates: z.array(z.array(z.array(z.tuple([z.number(), z.number()])))),
});

export const polygonGeoJsonFeatureSchema = z.object({
  type: z.literal('Polygon'),
  coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
});

// TODO: infer the type using the zod schema instead. However this won't work until we set strictNullChecks to true in tsconfig.json. We should probably do that one day, but it's a lot of work to fix all the errors that will come up.
export type PolygonGeoJsonFeature = {
  type: 'Polygon';
  coordinates: Array<Array<[number, number]>>;
};

// TODO: infer the type using the zod schema instead. However this won't work until we set strictNullChecks to true in tsconfig.json. We should probably do that one day, but it's a lot of work to fix all the errors that will come up.
export type MultiPolygonGeoJsonFeature = {
  type: 'MultiPolygon';
  coordinates: Array<Array<Array<[number, number]>>>;
};

export type PolygonsGeoJsonFeature =
  | PolygonGeoJsonFeature
  | MultiPolygonGeoJsonFeature;
